module.exports = __webpack_public_path__ + "static/vib_play8-f5e4fb9dbbdf6618b7c43b5ea9103b2f.jpg";